<svg-icon
  [src]="_src"
  [svgClass]="size + ' fill stroke'"
  [ngStyle]="styles"
></svg-icon>
